module.exports = __webpack_public_path__ + "img/2027.8b2a2d08.svg";